import React from 'react';
import cn from 'classnames';
import { Outlet } from 'react-router-dom';
import navStyles from '@layouts/PrimaryLayout/Navigation/Navigation.module.scss';
import layoutStyles from '@layouts/PrimaryLayout/PrimaryLayout.module.scss';
import { useAuthContext } from '@hooks/use-auth-context';
import PrimaryLayout from './PrimaryLayout';
import { Logo } from '@components/Icons';

export function UnauthenticatedLayout({ children = null }) {
  return (
    <div className={cn(layoutStyles.container, layoutStyles.unauthenticatedUser)}>
      <nav className={cn(navStyles.container, layoutStyles.nav)}>
        <div className={navStyles.content}>
          <div className={navStyles.header}>
            <a className={navStyles.brandContainer} href="/">
              <Logo width={31} preserveAspectRatio="xMidYMin meet" title="Clay" />
            </a>
          </div>
        </div>
      </nav>
      {children}
    </div>
  );
}

export function ShareLayout() {
  const { user } = useAuthContext();

  return !user ? (
    <UnauthenticatedLayout>
      <Outlet />
    </UnauthenticatedLayout>
  ) : (
    <PrimaryLayout />
  );
}
